<div class="age-filter-wrapper" style="border-radius: 0px !important;">
  <!-- Header with hamburger -->
  <div class="filter-header">
    <span>
      <img
        class="inbox-search-option"
        src="assets/qwyn/icons/hamburger_menu.svg"
        alt="hamburger_icon"
      />
    </span>
  </div>

  <hr class="divider" />

  <!-- MAIN CONTENT -->
  <div class="filter-condition">
    <!-- 1) OPERATOR DROPDOWN (Equals / Does not equal / Before / After / Blank / Not blank) -->
    <div class="select-wrapper">
      <button
        type="button"
        class="dropdown-trigger"
        (click)="toggleOperatorDropdown()"
        [class.dropdown-open]="operatorDropdownOpen"
      >
        <span>{{ getOperatorLabel(operator) }}</span>
        <img src="assets/qwyn/icons/filter_dropdown.svg" class="select-icon" alt="dropdown_icon" />
      </button>

      <div *ngIf="operatorDropdownOpen" class="dropdown-panel">
        <button
          *ngFor="let op of operatorOptions"
          type="button"
          class="dropdown-option"
          [class.selected]="op.value === operator"
          (click)="selectOperator(op.value)"
        >
          {{ op.label }}
        </button>
      </div>
    </div>

    <!-- 2) RANGE DROPDOWN (hidden for Blank / Not blank) -->
    <div class="select-wrapper" *ngIf="operator !== 'blank' && operator !== 'notBlank'">

      <!-- Trigger -->
      
      <button
        type="button"
        class="dropdown-trigger"
        (click)="toggleRangeDropdown()"
        [class.dropdown-open]="rangeDropdownOpen"
      >
        <span>{{ getRangeLabel(selectedRange) }}</span>
        <img src="assets/qwyn/icons/filter_dropdown.svg" class="select-icon" alt="dropdown_icon"/>
      </button>

      <div *ngIf="rangeDropdownOpen" class="dropdown-panel">
        <!-- “Select” acts as CLEAR -->
        <button
          type="button"
          class="dropdown-option"
          [class.selected]="selectedRange === null"
          (click)="selectRange(null)"
        >
          Select
        </button>

        <!-- Ranges -->
        <button
          *ngFor="let r of rangeOptions"
          type="button"
          class="dropdown-option"
          [class.selected]="r.value === selectedRange"
          (click)="selectRange(r.value)"
        >
          {{ r.label }}
        </button>
      </div>
    </div>
  </div>
</div>
